"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.THEME_CONSTANTS = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.inline-components"));

var _gerenciatdUnifiedicons = _interopRequireDefault(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedcomponents4 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.button"));

var _utils = require("./utils");

require("./PromoStripExtended.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const COMPONENT_NAME = 'PromoStripExtended';
const THEME_CONSTANTS = {
  ONLY_VISUAL: 'ONLY_VISUAL',
  CLICABLE_PILL: 'CLICABLE_PILL',
  PURCHARSE_MODE: 'PURCHARSE_MODE'
};
/**
 * compnente funcional para rendericar una banda indicativa de promo
 * @param {object} components componentes
 *  {object} mainContent titulo de la barra
 *  {object} claimContent claim de la  barra
 * @param {string} className clase css
 * @param {object} functionalClaim claim funcional
 * @param {object} purcharseButton boton
 * @param {Object} onClickTaggingInfo info de taggueo para el onclick
 * @returns {jsx}
 */

exports.THEME_CONSTANTS = THEME_CONSTANTS;

const PromoStripExtended = ({
  components,
  className,
  functionalClaim,
  purcharseButton,
  taggingInfo
}) => {
  // deifninios el tema
  const [onlyVisualTheme, purcharseModeTheme, clicablePillTheme] = (0, _utils.themeSelection)(functionalClaim, purcharseButton);
  let versionPaint = 'reducedtext';

  if (components && components['TextInfo-1']) {
    versionPaint = 'full';
  }

  const textSeparator = 'textSeparator';
  /**
   * constante para el claimContent
   */

  const claimContent = () => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "--claimContent item",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_gerenciatdUnifiedcomponents2.default, {
        direction: "row",
        justify: "evenly",
        wrap: "no-wrap",
        children: [components && components['TextInfo-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['TextInfo-2']), {}, {
          className: textSeparator
        })), components && components['SvgIconLoader-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread(_objectSpread({}, components['SvgIconLoader-1']), {}, {
          className: textSeparator
        }))]
      })
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: `promoStripExtended ${className} ${versionPaint}`,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_gerenciatdUnifiedcomponents2.default, {
      direction: "row",
      justify: "center",
      children: [(onlyVisualTheme || purcharseModeTheme) && claimContent(), clicablePillTheme && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
        taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
          componentName: COMPONENT_NAME
        }),
        onClick: functionalClaim.onClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "claimContentcontainer",
          children: claimContent()
        })
      }), components && components['TextInfo-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "--mainContent item",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, components['TextInfo-1']))
      }), purcharseModeTheme && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "--ctaContent item",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, {
          target: "_self",
          color: _gerenciatdUnifiedcomponents4.BUTTON_COLOR.WHITE_BLUE,
          label: purcharseButton.label,
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentName: COMPONENT_NAME
          }),
          size: {
            w: _gerenciatdUnifiedcomponents4.BUTTON_WIDTH.LIQUID,
            h: _gerenciatdUnifiedcomponents4.BUTTON_HEIGHT.MEDIUM
          },
          link: purcharseButton.link
        })
      })]
    })
  });
};

PromoStripExtended.propTypes = {
  /**
   * {
   *  "info": "compnentes necesarios para pintar la mínima expresión del componente",
   *  "kind": "both",
   *  "beautifulName": "components"
   * }
   */
  components: _propTypes.default.object.isRequired,

  /**
   * {
   *  "info": "clase modificadora para el css",
   *  "kind": "both",
   *  "beautifulName": "className"
   * }
   */
  className: _propTypes.default.string,

  /**
   * {
   *  "info": "claim funcional (onClick)",
   *  "kind": "both",
   *  "beautifulName": "functionalClaim"
   * }
   */
  functionalClaim: _propTypes.default.shape({
    onClick: _propTypes.default.func
  }),

  /**
   * {
   *  "info": "boton con link",
   *  "kind": "both",
   *  "beautifulName": "purcharseButton"
   * }
   */
  purcharseButton: _propTypes.default.shape({
    label: _propTypes.default.string,
    link: _propTypes.default.string
  }),

  /**
   * {
   *  "info": "boton con link",
   *  "kind": "both",
   *  "beautifulName": "purcharseButton"
   * }
   */
  taggingInfo: _propTypes.default.object
};
PromoStripExtended.defaultProps = {
  className: '',
  functionalClaim: {
    onClick: null
  },
  purcharseButton: {
    label: 'Contratar online',
    link: ''
  },
  taggingInfo: null
};
var _default = PromoStripExtended;
exports.default = _default;

//# sourceMappingURL=index.js.map